import React, { useState, useEffect } from 'react';

const SearchesPage = () => {
    const [searches, setSearches] = useState([]);
    const [loading, setLoading] = useState(false);

    // Données simulées pour les recherches sauvegardées
    const mockSearches = [
        {
            id: 1,
            title: "Développeur React Senior",
            keywords: "React, JavaScript, Node.js",
            location: "Dakar",
            type: "CDI",
            salaryMin: 800000,
            salaryMax: 1200000,
            dateCreated: "2024-01-15",
            alertsEnabled: true,
            resultsCount: 12
        },
        {
            id: 2,
            title: "Chef de Projet IT",
            keywords: "Gestion de projet, Agile, Scrum",
            location: "Dakar",
            type: "CDI",
            salaryMin: 1000000,
            salaryMax: 1500000,
            dateCreated: "2024-01-10",
            alertsEnabled: false,
            resultsCount: 8
        },
        {
            id: 3,
            title: "Designer UI/UX",
            keywords: "Figma, Adobe XD, Prototypage",
            location: "Dakar",
            type: "Freelance",
            salaryMin: 600000,
            salaryMax: 900000,
            dateCreated: "2024-01-08",
            alertsEnabled: true,
            resultsCount: 15
        }
    ];

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setSearches(mockSearches);
            setLoading(false);
        }, 1000);
    }, []);

    const toggleAlert = (id) => {
        setSearches(searches.map(search => 
            search.id === id ? { ...search, alertsEnabled: !search.alertsEnabled } : search
        ));
    };

    const deleteSearch = (id) => {
        setSearches(searches.filter(search => search.id !== id));
    };

    const formatSalary = (amount) => {
        return new Intl.NumberFormat('fr-FR').format(amount) + ' FCFA';
    };

    if (loading) {
        return (
            <div className="card border-0 shadow-sm" style={{borderRadius: '15px'}}>
                <div className="card-body p-5 text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Chargement...</span>
                    </div>
                    <p className="mt-3 text-muted">Chargement de vos recherches...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="card border-0 shadow-sm" style={{borderRadius: '15px'}}>
            <div className="card-header bg-transparent border-0 p-4">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h4 className="fw-bold mb-1">
                            <i className="fa fa-search me-2 text-warning"></i>
                            Mes Recherches Sauvegardées
                        </h4>
                        <p className="text-muted mb-0">{searches.length} recherche{searches.length > 1 ? 's' : ''} active{searches.length > 1 ? 's' : ''}</p>
                    </div>
                    <button className="btn btn-primary rounded-pill">
                        <i className="fa fa-plus me-2"></i>
                        Nouvelle recherche
                    </button>
                </div>
            </div>
            <div className="card-body p-4">
                {searches.length === 0 ? (
                    <div className="card border-0 bg-light text-center p-5" style={{borderRadius: '12px'}}>
                        <i className="fa fa-search fa-3x text-muted mb-3"></i>
                        <h5>Aucune recherche sauvegardée</h5>
                        <p className="text-muted mb-4">Sauvegardez vos recherches pour recevoir des alertes automatiques</p>
                        <button className="btn btn-primary rounded-pill">
                            <i className="fa fa-plus me-2"></i>
                            Créer une recherche
                        </button>
                    </div>
                ) : (
                    <div className="row">
                        {searches.map((search) => (
                            <div key={search.id} className="col-lg-6 col-12 mb-4">
                                <div className="card border-0 shadow-sm h-100" style={{borderRadius: '12px'}}>
                                    <div className="card-body p-4">
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <div>
                                                <h5 className="fw-bold mb-2">{search.title}</h5>
                                                <div className="d-flex align-items-center mb-2">
                                                    <span className={`badge ${search.alertsEnabled ? 'bg-success' : 'bg-secondary'} rounded-pill me-2`}>
                                                        <i className={`fa ${search.alertsEnabled ? 'fa-bell' : 'fa-bell-slash'} me-1`}></i>
                                                        {search.alertsEnabled ? 'Alertes ON' : 'Alertes OFF'}
                                                    </span>
                                                    <span className="badge bg-info rounded-pill">
                                                        {search.resultsCount} résultat{search.resultsCount > 1 ? 's' : ''}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="dropdown">
                                                <button className="btn btn-outline-secondary btn-sm rounded-pill" data-bs-toggle="dropdown">
                                                    <i className="fa fa-ellipsis-v"></i>
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <button className="dropdown-item" onClick={() => toggleAlert(search.id)}>
                                                            <i className={`fa ${search.alertsEnabled ? 'fa-bell-slash' : 'fa-bell'} me-2`}></i>
                                                            {search.alertsEnabled ? 'Désactiver' : 'Activer'} les alertes
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item">
                                                            <i className="fa fa-edit me-2"></i>
                                                            Modifier
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item">
                                                            <i className="fa fa-copy me-2"></i>
                                                            Dupliquer
                                                        </button>
                                                    </li>
                                                    <li><hr className="dropdown-divider" /></li>
                                                    <li>
                                                        <button className="dropdown-item text-danger" onClick={() => deleteSearch(search.id)}>
                                                            <i className="fa fa-trash me-2"></i>
                                                            Supprimer
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <div className="row g-2">
                                                <div className="col-6">
                                                    <small className="text-muted d-block">Mots-clés</small>
                                                    <span className="fw-semibold">{search.keywords}</span>
                                                </div>
                                                <div className="col-6">
                                                    <small className="text-muted d-block">Localisation</small>
                                                    <span className="fw-semibold">
                                                        <i className="fa fa-map-marker-alt me-1"></i>
                                                        {search.location}
                                                    </span>
                                                </div>
                                                <div className="col-6">
                                                    <small className="text-muted d-block">Type de contrat</small>
                                                    <span className="badge bg-primary rounded-pill">{search.type}</span>
                                                </div>
                                                <div className="col-6">
                                                    <small className="text-muted d-block">Salaire</small>
                                                    <span className="fw-semibold" style={{fontSize: '12px'}}>
                                                        {formatSalary(search.salaryMin)} - {formatSalary(search.salaryMax)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <small className="text-muted">
                                                <i className="fa fa-calendar me-1"></i>
                                                Créée le {new Date(search.dateCreated).toLocaleDateString('fr-FR')}
                                            </small>
                                            <button className="btn btn-primary btn-sm rounded-pill">
                                                <i className="fa fa-search me-1"></i>
                                                Voir les résultats
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchesPage;
